import { useState } from 'react';
import { Button } from 'shared-components';
import { UploadZone } from '../uploader/upload-zone';
import { close } from '../modal/modalSlice';
import { ButtonTier } from 'shared-components';
import { useAppDispatch } from '../../app/hooks';
import { Upload } from '../uploader/uploader.types';
import { useSetCoverMutation as useSetEventCoverMutation } from './events.api';
import { useSetAlbumCoverMutation } from '../albums/albums.api';
import styles from './cover-upload-modal.module.css';

export const CoverUploadModal = ({
  eventId,
  albumId,
}: {
  eventId?: string;
  albumId?: string;
}) => {
  const dispatch = useAppDispatch();
  const [uploadList, setUploadList] = useState<
    Pick<Upload, 'file' | 'destination'>[]
  >([]);
  const [setEventCover] = useSetEventCoverMutation();
  const [setAlbumCover] = useSetAlbumCoverMutation();
  return (
    <div className={styles.coverUploadModal}>
      <UploadZone
        className={styles.uploadZone}
        allowMultiple={false}
        onlyOneMessage="Please select only one file"
        onFileChange={(files) => {
          const newList = files.map((file) => ({
            file,
            destination: `https://localhost:3001/api/events/${eventId}/cover`,
          }));
          setUploadList(newList);
        }}
      />
      <Button
        bigger={true}
        tier={ButtonTier.Secondary}
        onClick={() => {
          dispatch(close());
        }}
      >
        Cancel
      </Button>
      {uploadList.length > 0 && (
        <Button
          bigger={true}
          onClick={async () => {
            if (eventId) {
              await setEventCover({
                id: eventId,
                image: uploadList[0].file,
              });
            } else if (albumId) {
              await setAlbumCover({
                id: albumId,
                image: uploadList[0].file,
              });
            }
            dispatch(close());
          }}
        >
          Upload
        </Button>
      )}
    </div>
  );
};
